import React, { Component } from "react";
import TopOptions from "../components/TopOptions";
import styled from "styled-components";
import CustomInput from "../components/CustomInput";
import FlashMessages from "../helpers/FlashMessages";
import { errorMessage } from "../tmp/Messages";
import { connect } from "react-redux";

import PlanningDAO from "../DAO/PlanningDAO";
import { MessagesText } from "../values/MessagesText";
import CustomDatePicker from "../components/CustomDatePicker";
import { DatePicker } from "../components/CustomDatePicker";
import { RoutesPath } from "../values/RoutesPath";
import UserDAO from "../DAO/UserDAO";
import CustomSelect from "../components/CustomSelect";
import FromLoading from "../helpers/FromLoading";
import { Bloc, FormContainer, Left, Right, InputContainer } from "../helpers/formStyledComp";
import moment from "moment";
import { notify } from "../helpers/FlashMessage";

/**
 *
 * this component can used for persist and update  account
 * if id_account not 0 means update
 * else mean persist
 *
 */

class AddPlanningPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            planning_id: 0,
            users: [],

            fields: {
                name: { value: "", error: false },
                start_date: { value: new Date(), error: false },
                error: false,
                end_date: { value: null, error: false },
                manager: { value: "", error: false },
            },
            loading: false,
        };
    }

    componentDidMount() {
        document.title = "Comptes - Sobrus Labs";
        const id = this.props.match.params.id;
        const { fields } = this.state;
        this.getUsers();
        !id && this.getConnectedUserInfos();
        if (id) {
            this.setState({ planning_id: id });
            this.get();
        }
    }

    async get() {
        try {
            const id = this.props.match.params.id;
            const response = await PlanningDAO.getPlanningById(id, {});
            const planning = response.data.planning;

            planning.nom && this.setFields("name", "value", planning.nom);
            planning.date_debut && this.setFields("start_date", "value", new Date(planning.date_debut));
            planning.date_fin && this.setFields("end_date", "value", new Date(planning.date_fin));
            planning.gestionnaire_id && this.setFields("manager", "value", planning.gestionnaire_id);
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }

    verifyRequired() {
        const { fields } = this.state;
        if (fields.name && fields.name.value && fields.name.value.length !== 0 && fields.manager && fields.manager.value && fields.manager.value.length !== 0 && fields.start_date && fields.start_date.value && fields.end_date && fields.end_date.value) {
            const data = {
                nom: fields.name.value,
                date_debut: moment(fields.start_date.value).format("YYYY-MM-DD"),
                date_fin: moment(fields.end_date.value).format("YYYY-MM-DD"),
                gestionnaire: fields.manager.value,
            };
            return data;
        } else {
            if (!fields.name.value || (fields.name.value && fields.name.value.length === 0)) this.setFields("name", "error", true);
            if (!fields.manager.value || (fields.manager.value && fields.manager.value.length === 0)) this.setFields("manager", "error", true);
            if (!fields.start_date.value) this.setFields("start_date", "error", true);
            if (!fields.end_date.value) this.setFields("end_date", "error", true);
        }
    }

    async add() {
        try {
            const data = this.verifyRequired();
            if (data) {
                this.setState({ loading: true });
                const response = await PlanningDAO.addPlanning({}, data);
                this.setState({ loading: false });
                if (!response.data.msg && response.data.status === "ok") {
                    notify({ msg: MessagesText.planning.add, type: "success" });
                    this.props.history.push(`${RoutesPath.planning.details}/${response.data.planning.id}`);
                } else {
                    notify({ msg: response.data.msg, type: "danger" });
                }
            }
        } catch (error) {
            this.setState({ loading: false });
            notify({ msg: error.message, type: "danger" });
        }
    }

    async update() {
        try {
            const data = this.verifyRequired();
            if (data) {
                const id = this.state.planning_id;
                this.setState({ loading: true });
                const response = await PlanningDAO.updatePlanning(id, {}, data);
                this.setState({ loading: false });
                if (!response.data.msg && response.data.status === "ok") {
                    notify({ msg: MessagesText.planning.update, type: "success" });
                    this.props.history.push(`${RoutesPath.planning.details}/${response.data.planning.id}`);
                } else {
                    notify({ msg: response.data.msg, type: "danger" });
                }
            }
        } catch (error) {
            this.setState({ loading: false });
            notify({ msg: error.message, type: "danger" });
        }
    }

    setFields(field, property, value) {
        this.setState((prevState) => ({
            ...prevState,
            fields: {
                ...prevState.fields,
                [field]: {
                    ...prevState.fields[field],
                    [property]: value,
                },
            },
        }));
    }
    async getUsers() {
        try {
            const data = {
                pagination: {
                    value: "OFF",
                },
            };
            const response = await UserDAO.getALLUsers(1, {}, data);
            this.setState({ users: response.data.utilisateurs });
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }
    async getConnectedUserInfos() {
        try {
            const params = {};
            const response = await UserDAO.getConnectedUserInfos(params);
            this.setFields("manager", "value", response.data.id);
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }
    render() {
        const { loading, planning_id, fields, errorMessage, users } = this.state;
        const title = planning_id !== 0 ? `Modifier Planning : ${fields.name.value}` : `Créer un nouveau planning`;
        const subTitle = planning_id !== 0 ? `Modifier Planning` : `Créer un planning`;

        return (
            <Main_container className="Main_container">
                <FlashMessages successMessage={""} errorMessage={errorMessage} />
                <PopUp></PopUp>
                {loading && <FromLoading />}
                <TopOptions title={title}>
                    <button className="btn_bleu" data-shortcut_alias="create" onClick={() => (planning_id !== 0 ? this.update() : this.add())}>
                        Sauvegarder
                    </button>
                </TopOptions>
                <Bloc className="Bloc">
                    <div className="bloc_header">
                        <h2>{subTitle}</h2>
                        <div className="bloc_header_btns"></div>
                    </div>
                    <FormContainer>
                        <Left>
                            <InputContainer>
                                <CustomSelect
                                    error={fields.manager.error}
                                    onChange={(value) => {
                                        this.setFields("manager", "value", value.target.value);
                                        this.setFields("manager", "error", false);
                                    }}
                                    selectedValue={fields.manager.value}
                                    label="Gestionnaire"
                                >
                                    <option defaultValue></option>
                                    {users.map((user, index) => {
                                        return (
                                            <option key={"key_" + index} value={user.id}>
                                                {user.fullname}
                                            </option>
                                        );
                                    })}
                                </CustomSelect>
                            </InputContainer>
                            <InputContainer>
                                <DatePicker
                                    error={fields.start_date.error}
                                    selected={fields.start_date.value}
                                    onChange={(date) => {
                                        this.setFields("start_date", "value", date);
                                        this.setFields("start_date", "error", false);
                                    }}
                                    label="Date de début*"
                                    id="start_date_id"
                                    dateFormat="yyyy-MM-dd"
                                    showTimeSelect={false}
                                />
                            </InputContainer>
                        </Left>
                        <Right>
                            <InputContainer>
                                <CustomInput
                                    error={fields.name.error}
                                    onChange={(value) => {
                                        this.setFields("name", "value", value.target.value);
                                        this.setFields("name", "error", false);
                                    }}
                                    defaultValue={fields.name.value}
                                    value={fields.name.value}
                                    id="name"
                                    label="Nom *"
                                ></CustomInput>
                            </InputContainer>
                            <InputContainer>
                                <DatePicker
                                    error={fields.end_date.error}
                                    selected={fields.end_date.value}
                                    onChange={(date) => {
                                        this.setFields("end_date", "value", date);
                                        this.setFields("end_date", "error", false);
                                    }}
                                    label="Date de fin*"
                                    id="end_date_id"
                                    dateFormat="yyyy-MM-dd"
                                    showTimeSelect={false}
                                    minDate={fields.start_date.value}
                                />
                            </InputContainer>
                        </Right>
                    </FormContainer>
                </Bloc>
            </Main_container>
        );
    }
}

const Main_container = styled.div`
    height: 100%;
    position: relative;
`;
const PopUp = styled.div`
    background: rgba(0, 0, 0, 0.7);
    position: ;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

const Left_Input_container = styled.div`
    width: 48%;
    height: 41px;
    display: inline-block;
    vertical-align: top;
`;
const Right_input_container = styled.div`
    width: 48%;
    height: 41px;
    display: inline-block;
    vertical-align: top;
    margin-left: 51px;
`;
const Form_container = styled.div`
    margin-top: 38px;
`;
const Row = styled.div`
    width: 94%;
    margin: auto;
    margin-top: 18px;
`;

const mapStateToProps = (state) => {
    return {
        selected: state.selcted,
    };
};
export default connect(mapStateToProps)(AddPlanningPage);
